import { z } from "zod";

const configNameSchema = z.string().trim().min(1).max(100);

export const configurationInputSchema = z.object({
  name: configNameSchema,
});

export const configurationPatchSchema = z
  .strictObject({
    name: configNameSchema.optional(),
    locked: z.boolean().optional(),
  })
  .refine((value) => Object.keys(value).length > 0, { message: "Nothing to update" });

export type ConfigurationInput = z.infer<typeof configurationInputSchema>;
export type ConfigurationPatch = z.infer<typeof configurationPatchSchema>;
